module.exports = __webpack_public_path__ + "static/media/torna.bf20213b.jpg";